import { Currency } from './../models/currency.model'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { ApiService } from './api.service'
@Injectable({ providedIn: 'root' })
export class CurrencyService {
  constructor(private apiService: ApiService) {}

  getCurrenciesList(): Observable<Currency[]> {
    return this.apiService.get('/currencies').pipe(map((resp) => <Currency[]>resp['data']))
  }
}
